import { useState } from "react";
import Autocomplete from "../../library/Autocomplete";

interface TagsFilterAutocompleteProps {
  onChange: (e: React.SyntheticEvent) => void;
  onBlur?: (e: React.SyntheticEvent) => void;
  onKeyDown?: (e: React.SyntheticEvent) => void;
  filterBy?: (option: any, props: any) => any;
  options: string[];
  selected: string[];
  placeholder?: string;
  reactRef: React.RefObject<HTMLElement> | ((e: React.SyntheticEvent) => void);
  style?: {[key:string]:string};
}

function TagsFilterAutocomplete(props: TagsFilterAutocompleteProps) {
  const renderNewTagSelectionElement = (searchTag:string) => {
    return (
      <span>
        New filter: 
      </span>
    );
  }
  const [newSelectionPrefix, setNewSelectionPrefix] = useState(
    renderNewTagSelectionElement("")
  );

  const onInputChange = (searchString:any) => {
    setNewSelectionPrefix(renderNewTagSelectionElement(searchString));
  }

  return <Autocomplete 
            id="tagsAutocomplete"
            reactKey="tagsAutocomplete"
            allowNew
            placeholder={props.placeholder}
            newSelectionPrefix={newSelectionPrefix}
            onInputChange={onInputChange}
            onChange={props.onChange} 
            onBlur={props.onBlur}
            style={props.style}
            options={props.selected}
            selected={props.selected}
            paginate={false} 
            reactRef={props.reactRef}
            onKeyDown={props.onKeyDown}
            filterBy={props.filterBy}
            multiple
          />;
}

export default TagsFilterAutocomplete;
